var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "ico-package",
    width: 22,
    height: 25,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAZCAYAAAA14t7uAAACAklEQVRIibWWMUgjQRSGvywiChaiIoJYiik0kEoQBAsbkcPKa7SSiEiu0nSXUiu1UxsFi9PuCgst9FLGQi1EbJRw1YEcd5aCFkGPB//IGHfj7oE/DDv7z3t/5r158zYp9o6IiU49/8QxDmLYtAIrwC+NFXH/LdwA5IEKUAAaNQri8rJJJDwOXAHrQIe47xqIs7XfwGIc4QzwAzgA0uLOgWFgUmNMgoZ2YFU+mTDhLmALuABGxVk+p4FBoOyl5pvsDc96jsp3y60FMr4Fcnq/B4pAH7An56jU9Mv2Xr45aeVtF5+BlIyftKMN4EHhrXlRuNQsKAok1A3MSdy0JgLtxIVl7/PAT+AkZmoq8gm81JzZS9X7ZXfqbcCQjB8TpOZW86pfFVWdulXAncc3ASNAb4yqcZsMreOyru+MwnenfqkRlZpXiLogFu6Owi8qHQ5hqXmDyCspWGUs22EAx+I+AaV3/GI1IcNfb35Xxy6xcGJ8qLArkR7/rieE6zU9vvB+zV23m/QVaI6h3SzbSk2vKQWqQSv+bfWKFmAJuAGmvD7iI6W1G9m2yHdbWmWXY+uvs0DWKyULaxc4Fe+QFbfrhV4SP+t6ddTHdFwNPB226OFan6rDsMMLgxkOAF8i6tY4WzObN6L1hA1WLdaXLWebHm9z42ztpenUIsn/CpcWC78+gH8GP4gAy1Vr1wAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPackage);
export default __webpack_public_path__ + "static/media/ico-package.6e37fc62.svg";
export { ForwardRef as ReactComponent };